import { useState, useEffect } from "react"
import { getFunctions, httpsCallable } from 'firebase/functions';
import app, { database } from "./services/firebase";

const functions = getFunctions(app);
const ENV = 'devs'

import SignIn from "./SignIng";
import Dashboard from "./Dashboard";
import Exam from "./Exam";

export default function App() {
  const [loaded, setLoaded] = useState(false);

  const [exam, setExam] = useState(false);
  const [examSelected, setExamSelected] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const loginInstitute = httpsCallable(functions, 'loginInstitute');
        const { data } = await loginInstitute({ env: ENV});
        if(!data.token){
          console.error('loginInstitute info', data);
        }
        localStorage.setItem("token", data.token);
        localStorage.setItem("environment", data.environment);
        localStorage.setItem("env", data.env);
      } catch (error) {
        console.error('Firebase healthcheck failed', error);
      }
    })();
  }, []);

  const blLogin = () => {
    let myHeaders = new Headers();
    myHeaders.append("Agent", "Klarway-ext");

    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders
    };
    
    fetch(`${localStorage.getItem("k_url")}/${localStorage.getItem("environment")}/blLogin?user=id${localStorage.getItem("user")}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("result blLogin", result);
        global.consultRegistry();
      })
      .catch((error) => console.log("error", error));
  };

  global.loginSuccessful = () => {
    blLogin();
    setLoaded(true);
  };

  global.consultRegistry = () => {
    const username = localStorage.getItem("user");
    
    let formdata = new FormData();
    formdata.append("user", localStorage.getItem("user"));
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    formdata.append("email", `${username}@sisklarway.com`);

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/blConsultRegistry/v2`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          console.log("existe el usuario!!!!!");
        } else {
          console.log("NO existe el usuario");
          global.setUserForPadron();
        }
      })
      .catch((error) => console.log("error blConsultRegistry", error));
  };

  global.checkExam = async (examId, courseId) => {
    let formdata = new FormData();
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    formdata.append("exam_uuid", examId);
    formdata.append("course_id", courseId);

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    try {
      const response = await fetch(`${localStorage.getItem("k_url")}/checkExam/v2`, requestOptions);
      const result = await response.json();
      const success = Boolean(result?.success);
      console.log('checkExam result', result);
      return success;
    } catch (error) {
      console.log("error /checkExam/v2", error);
      return false;
    }
  };

  global.changeActivationExam = async (exam_id, course_id, examTitle, courseTitle) => {
    const checkExam = await global.checkExam(exam_id, course_id);

    var formdata = new FormData();
    // formdata.append("user", localStorage.getItem("user"));
    // user_id
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    formdata.append("exam_uuid", exam_id);
    formdata.append("course_id", course_id);
    formdata.append("exam_title", examTitle);
    formdata.append("course_title", courseTitle);
    // formdata.append("lms", 'sis');
    formdata.append("active", !checkExam);
    // formdata.append("isExtension", localStorage.getItem("isExtension"));

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/activateKlarway`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          console.log("activateKlarway success");
        } else {
          // llamo al del registro - setUserForPadron
          console.log("activateKlarway fails");
          // global.setUserForPadron();
        }
        return result
      })
      .catch((error) => {
        console.log("error activateKlarway", error)
        return false
      });
  };

  global.setUserForPadron = () => {
    const username = localStorage.getItem("user");

    let formdata = new FormData();
    formdata.append("id", username);
    formdata.append("firstname", username);
    formdata.append("lastname", username);
    formdata.append("user", username);
    formdata.append("email", `${username}@sisklarway.com`);
    formdata.append("identifier", '123456'); // TODO

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/setUserForPadron`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("setUserForPadron result!", result);
        if (result.success) {
          console.log("llamo a activatePadronApp");
          activatePadronApp();
        }
      })
      .catch((error) => console.log("error", error));
  };

  const activatePadronApp = () => {
    let formdata = new FormData();
    formdata.append("key", localStorage.getItem("klarwayProctoringKey"));
    formdata.append("user_id", localStorage.getItem("user"));

    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
    myHeaders.append("Agent", "Klarway-ext");

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${localStorage.getItem("k_url")}/activatePadronApp`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log("activatePadronApp result!", result))
      .catch((error) => console.log("activatePadronApp error", error));
  };

  global._closeSession = () => {
    setLoaded(false);
    localStorage.removeItem("user");
  };

  global.showExam = (examId, courseId, attempt) => {
    setExamSelected({examId:examId, courseId:courseId, attempt:attempt})
    setExam(true);
  };

  global.closeExam = () => {
    setExam(false);
  };

  return loaded ? (
    exam ? (
      <Exam examSelected={examSelected} ></Exam>
    ) : (
      <Dashboard></Dashboard>
    )
  ) : (
    <SignIn></SignIn>
  );
}
